import { Pipe, PipeTransform } from '@angular/core';
import { ValidaCnpjService } from '../services/valida-cnpj.service';
import { isNullOrUndefined } from '../../util/is-null-or-undefined.util';

@Pipe({
  name: 'MaskCnpjPipe',
  standalone: false,
})
export class MaskCnpjPipe implements PipeTransform {
  constructor(private servicoValidadorCnpj: ValidaCnpjService) {}
  /**
   * Método responsável por manipular o texto e aplicar/remover máscara
   *
   * @param texto
   * @param removeMascara
   */
  transform(texto: string, removeMascara: boolean): string {
    if (!texto) return '';

    texto = this.retirarFormatacao(texto);

    if (removeMascara) {
      return texto;
    }

    if (texto.length === 14) {
      if (this.servicoValidadorCnpj.validarCNPJ(texto)) {
        return this.mascaraCnpj(texto);
      }
    }

    return this.mascaraCnpj(texto);
  }

  /**
   * Método que remove caracteres especiais do texto
   *
   * @param texto
   */
  retirarFormatacao(texto: string): string {
    if (isNullOrUndefined(texto)) {
      return texto;
    }
    return texto.toString().replace(/(\.|\/|\-)/g, '');
  }

  /**
   * Método responsável por aplicar máscara de cnpj ao texto
   *
   * @param valor
   */
  private mascaraCnpj(valor: string): string {
    // Aceita letras ou números nos 12 primeiros, números nos 2 últimos
    // Exemplo: AA.AAA.AAA/AAAA-00
    if(valor === "Selecione"){
      return valor
    }

    valor = valor.toUpperCase();
    const len = valor.length;

    // Apply mask progressively based on length
    if (len <= 2) {
      return valor;
    } else if (len <= 5) {
      return valor.replace(/^([A-Za-z0-9]{2})([A-Za-z0-9]+)$/, '$1.$2');
    } else if (len <= 8) {
      return valor.replace(/^([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]+)$/, '$1.$2.$3');
    } else if (len <= 12) {
      return valor.replace(/^([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]+)$/, '$1.$2.$3/$4');
    } else {
      return valor.replace(
        /^([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})(\d{0,2})$/,
        '$1.$2.$3/$4-$5'
      );
    }
  }
}
